import React, {useEffect, useState} from 'react';
import {Modal} from "antd";
import Paragraph from "antd/es/typography/Paragraph";
import {ViewFilePreviewColumnsPreferencesList} from "./ViewFilePreviewColumnsPreferencesList";


export const ViewFilePreviewColumnsPreferences = ({columns, visible, onCancel, onOk}) => {

    const [internalColumns, setInternalColumns] = useState([]);

    useEffect(() => {
        setInternalColumns(columns.map(column => ({
            name: column.name,
            visible: true
        })));
    }, [columns]);

    function handleOk() {
        onOk(internalColumns);
    }

    function handleColumns(columns) {
        setInternalColumns([...columns]);
    }

    return <Modal title="Preferences" open={visible} onCancel={onCancel} onOk={handleOk}>
        <Paragraph style={{overflowY: "auto", maxHeight: "70vh"}}>
            <ViewFilePreviewColumnsPreferencesList columns={internalColumns} updateColumns={handleColumns}/>
        </Paragraph>
    </Modal>


}